import * as React from 'react';
import { UIHeading4, UIText2, LinkButton } from '@cian/ui-kit';

import * as styles from './styles.css';
import { useIsDesktop } from '@cian/valuation-utils-component';

interface IAddOfferProps {
  title: string;
  onActionClick(): void;
}

export const AddOffer = React.forwardRef<HTMLDivElement, IAddOfferProps>(({ onActionClick, title }, ref) => {
  const isDesktop = useIsDesktop();

  return (
    <div ref={ref} className={styles['container']}>
      <div className={styles['content']}>
        <UIHeading4>{title}</UIHeading4>
        <div className={styles['text']}>
          <UIText2>
            Укажите цену в диапазоне оценки и получите значок «Хорошая цена». Вместе со значком «Собственник»
            это привлечёт больше просмотров и звонков.
          </UIText2>
        </div>
      </div>
      <div className={styles['button']}>
        <LinkButton
          onClick={onActionClick}
          href="https://www.cian.ru/razmestit-obyavlenie/"
          size={isDesktop ? 'XS' : 'M'}
          fullWidth={!isDesktop}
        >
          Разместить объявление
        </LinkButton>
      </div>
    </div>
  );
});

AddOffer.displayName = 'AddOffer';
